import { PageHeader } from "@ligo/layout-design-core";
import useViewModel from "./viewModel";

const Header = () => {
  const vm = useViewModel();
  const { header } = vm;

  if (!header) return <></>;

  return <PageHeader {...header} />;
};

export default Header;
